module.exports = __webpack_public_path__ + "static/media/logo.676fcc61.webp";